// Media/YouTube configuration. Provide your playlist ID to auto-embed latest videos.
// E.g., create a playlist and add new videos to it, or use the channel "Uploads" playlist ID.
// For the channel uploads playlist: if channel id is UCxxxx..., uploads playlist is UUxxxx...
export const YOUTUBE_PLAYLIST_ID = 'PLAYLIST_ID_REPLACE';
// Alternatively, provide the Channel ID (starts with 'UC').
// When set, we will auto-derive the "Uploads" playlist (replace UC -> UU).
export const YOUTUBE_CHANNEL_ID = 'UCHWKVXQDLU7GN5560JLsOcw';
// YouTube Data API key for fetching playlist items (required for carousel view)
// Create one at https://console.cloud.google.com/apis/credentials
export const YOUTUBE_API_KEY = 'YOUTUBE_API_KEY_REPLACE';
